import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import TopBar from './TopBar';
import Sidebar from './Sidebar';
import '../styles/Landlord.css';
import Swal from 'sweetalert2';
import { useLandlordGuard } from '../../../utils/authGuard';

const LandlordLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const { isAuthorized } = useLandlordGuard();

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 991;
      setIsMobile(mobile);
      if (!mobile) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!isAuthorized) {
    return null;
  }

  // Close sidebar when clicking outside on mobile
  const handleContentClick = () => {
    if (isMobile && isSidebarOpen) {
      setIsSidebarOpen(false);
    }
  };

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className={`landlord-layout ${!isSidebarOpen ? 'collapsed' : ''}`}>
      <Sidebar 
        isOpen={isSidebarOpen} 
        onClose={handleSidebarClose}
      />
      <div 
        className="landlord-main"
        onClick={handleContentClick}
      >
        <TopBar 
          isSidebarOpen={isSidebarOpen} 
          onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}
        />
        <div className="main-content">
          <Outlet />
        </div>
      </div>
      {isMobile && isSidebarOpen && (
        <div 
          className="sidebar-overlay"
          onClick={handleSidebarClose}
        />
      )}
    </div>
  );
};

export default LandlordLayout; 